import { render, staticRenderFns } from "./categoryItem.vue?vue&type=template&id=53054026"
import script from "./categoryItem.vue?vue&type=script&lang=js"
export * from "./categoryItem.vue?vue&type=script&lang=js"
import style0 from "./categoryItem.vue?vue&type=style&index=0&id=53054026&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports